import { GetEarlyRepaymentSimulationResponse } from '@iwoca/lapi-client/edge';
import { Button, Icon } from '@iwoca/orion';
import { t, Trans } from '@lingui/macro';
import { useAmplitude } from 'hooks/useAmplitude';
import { useLocale } from 'hooks/useLocale';
import { useNumberFormat } from 'hooks/useNumberFormat';
import { CSVLink } from 'react-csv';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';

type TProps = {
  schedule: GetEarlyRepaymentSimulationResponse['data']['schedule'];
};

export const ExportRepaymentScheduleToCSVButton = ({ schedule }: TProps) => {
  const { trackEvent } = useAmplitude();
  const { i18n } = useLocale();
  const { formatCurrency } = useNumberFormat();

  const data = schedule.map(
    ({ date, principal, interest, total_fees, total }) => ({
      [t`Date`]: i18n.date(date, {
        day: '2-digit',
        month: 'numeric',
        year: 'numeric',
      }),
      [t`Original loan`]: formatCurrency(principal),
      [t`Fees + interest`]: formatCurrency(interest + total_fees),
      [t`Total`]: formatCurrency(total),
    }),
  );
  return (
    <CSVLink
      data={data}
      filename={`${t`export`}_${new Date()
        .toLocaleDateString()
        .replaceAll('/', '-')}_${new Date()
        .toLocaleTimeString()
        .replaceAll(':', '-')}`}
    >
      <Button
        variant="tertiary"
        data-testid="export-repayment-schedule-button"
        size="small"
        onClick={() => trackEvent(AMPLITUDE_EVENTS.repaymentScheduleCSVExport)}
      >
        <Icon icon="download" />
        <Trans>Export CSV</Trans>
      </Button>
    </CSVLink>
  );
};
